module.exports = __webpack_public_path__ + "static/media/xiangshan_mobile.add3af07.webp";